import React from "react";

const Home = () => {
  return (
    <div
      data-testid="page-home"
      className="min-h-screen w-full flex items-center justify-center"
      style={{ backgroundColor: "#B22234" }}
    >
      <img
        src="/frdm-logo-white.webp"
        alt="FRDM"
        data-testid="frdm-logo"
        className="w-[70vw] max-w-[800px] h-auto"
      />
    </div>
  );
};

export default Home;
